import {http} from '@/http/index.js';

async function getConsumer(consumerId) {
  return http
    .get(`/consumers/${consumerId}`)
    .then((response) => response.data.data);
}

export {getConsumer};
